import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route/pathname change. If there is a hash, try to scroll to that anchor.
export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // If navigating to a hash anchor, honor it
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el && 'scrollIntoView' in el) {
        (el as HTMLElement).scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }
    }
    // Default: force window scroll to top
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch {
      // Fallbacks for older browsers
      (document.documentElement || document.body).scrollTop = 0;
      (document.scrollingElement as HTMLElement | null)?.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, location.search]);

  return null;
}
